module.exports = __webpack_public_path__ + "img/rastro.7b5c9d42.svg";